/* eslint-disable */
import React, { FC, useEffect, useRef, useState } from 'react'
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom'
import { toast, ToastOptions } from 'react-toastify'

import {
  ResumoDeDocumentosDeSaidaMapper,
  ResumoDeDocumentosAnalisados,
  UploadDeDocumentos,
  UploadDocumentos,
  useRelacaoDeDocumentos,
  selecaoDeDocumentosParaEnvio
} from 'src/compartilhados'
import {
  Breadcrumb,
  Carregando,
  ErroContainerLayout,
  ErroLayoutContainer,
  Modal,
  ModalRef
} from 'src/componentes'
import { Botao } from 'src/componentes/botao'
import { Api } from 'src/servicos'
import { getApiError } from 'src/servicos/instancias-api'
import {
  SituacaoUpload,
  TipoDocumentoAlunoCertificacao,
  ResumoDocumentosAlunoCertificacao
} from 'src/tipos'
import { AlunoCertificacaoPayload } from 'src/dto'

import {
  ModalMotivoRejeicao,
  ModalVisualizacaoDocumento,
  ModalVisualizacaoDocumentoRef
} from '../../ipgs/alunos/documentos/componentes'
import { ModalMotivoRejeicaoDados } from '../../ipgs/alunos/documentos/componentes/modal-motivo-rejeicao/modal-motivo-rejeicao.component'
import {
  BotaoDeSalvar,
  ContainerBreadcrumbs,
  ContainerDaPagina,
  ContainerDosBotoes,
  DescricaoContainer,
  Dicas,
  ParagrafoDaNacionalidade,
  TituloComplementar
} from '../../ipgs/alunos/documentos/style'
import { RejeicaoDocumento } from '../../ipgs/alunos/documentos/tipos'
import { MapearDocumentosAlunoCertificacao } from './mappers'
import {
  DICA_CONSULTA_DOCUMENTOS_FILA,
  useSomenteConsultaDocumentosFilaTrabalho
} from './somente-consulta-fila-trabalho'

const tituloDaPagina = 'Documentação Alunos'
const erroAoCarregarDados = 'Ops! Houve algum problema no carregamento dos dados.'
const erroAoBaixarDocumentos = 'Erro ao baixar documentos.'
const erroAoObterDocumentos = 'Não foi possível obter os documentos do aluno.'
const erroAoAtualizarDocumentos = 'Erro ao atualizar documentos.'
const erroAoEnviarDocumentos = 'Erro ao enviar documentos.'
const erroAoProcessarDocumentos = 'Erro ao processar documentos.'
const erroAoEnviarMotivoAlteracaoAprovado = 'Erro ao enviar motivo alteração'
const ErroAoEnviarAnalises = 'Erro ao enviar análise de aprovação de documentos.'
const toastOptions = { type: 'error' } as ToastOptions

export type DocumentosAlunoCertificacaoProps = RouteComponentProps<{
  id: string
}>

const DocumentosAlunoCertificacao: FC<DocumentosAlunoCertificacaoProps> = ({
  match
}) => {
  const history = useHistory()
  const somenteConsulta = useSomenteConsultaDocumentosFilaTrabalho()
  const { documentos, atualizar, reiniciar } = useRelacaoDeDocumentos()
  const [pronto, definirPronto] = useState<boolean>()
  const [carregando, definirCarregando] = useState<boolean>()
  const [dadosDoAluno, definirDadosDoAluno] = useState<AlunoCertificacaoPayload>()
  const [rejeicaoDeDocumento, definirRejeicaoDeDocumento] = useState<RejeicaoDocumento>()

  const modalDeCancelamentoRef = useRef<ModalRef>(null)
  const modalMotivoRejeicaoRef = useRef<ModalRef>(null)
  const modalVisualizacaoRef = useRef<ModalVisualizacaoDocumentoRef>(null)

  const { limparErro, definirErro, erro } = ErroLayoutContainer.useContainer()

  const montarUrlDeVisualizacao = (base64: string, contentType: string): string => {
    const base64Normalizado = base64?.trim()

    if (!base64Normalizado) return null
    if (base64Normalizado.startsWith('data:')) return base64Normalizado

    const tipoDoConteudo = contentType || 'application/pdf'
    return `data:${tipoDoConteudo};base64,${base64Normalizado}`
  }

  const obterAlunoPorId = async (id: string): Promise<AlunoCertificacaoPayload> => {
    try {
      const aluno = await Api.RequisitarAlunoCertificacao(id)
      return aluno
    } catch (error) {
      definirErro({ mensagens: erroAoCarregarDados })
      return null
    }
  }

  const obterResumoDeDocumentos = async (alunoId: string): Promise<void> => {
    try {
      const resumoDocumentos = await Api.ObterResumoDeDocumentosAlunoCertificacao(alunoId)

      if (resumoDocumentos?.length > 0) {
        const docs = MapearDocumentosAlunoCertificacao(resumoDocumentos)
        reiniciar(docs)
      }
    } catch (error) {
      definirErro({ mensagens: erroAoCarregarDados })
    }
  }

  const uploadDeCriacao = async (
    documentosParaEnvio: UploadDocumentos[]
  ): Promise<boolean> => {
    if (!documentosParaEnvio.length) return true

    const formulario = ResumoDeDocumentosDeSaidaMapper(documentosParaEnvio)
    const resposta = await Api.EnviarDocumentosAlunoCertificacao(
      dadosDoAluno.id,
      formulario
    )

    if (!resposta) {
      toast(erroAoEnviarDocumentos, toastOptions)
      return false
    }

    return true
  }

  const uploadDeEdicao = async (
    documentosParaEnvio: UploadDocumentos[]
  ): Promise<boolean> => {
    if (!documentosParaEnvio.length) return true

    const formulario = ResumoDeDocumentosDeSaidaMapper(documentosParaEnvio)
    const resposta = await Api.EditarDocumentosAlunoCertificacao(
      dadosDoAluno.id,
      formulario
    )

    if (!resposta) {
      toast(erroAoAtualizarDocumentos, toastOptions)
      return false
    }

    const documentosAprovados = documentosParaEnvio.filter(
      x => x.motivoAlteracaoAprovado
    )

    if (documentosAprovados.length > 0) {
      try {
        await Api.AlteracaoAprovado(dadosDoAluno.id, documentosAprovados)
      } catch {
        toast(erroAoEnviarMotivoAlteracaoAprovado, toastOptions)
      }
    }

    return true
  }

  const uploadDeAnalises = async (
    analises: UploadDocumentos[]
  ): Promise<boolean> => {
    if (!analises.length) return true

    const resultado = ResumoDeDocumentosAnalisados(analises)

    if (!resultado?.documentos?.length) return true

    const resposta = await Api.ValidarDocumentosAluno(resultado)

    if (!resposta) {
      toast(ErroAoEnviarAnalises, toastOptions)
      return false
    }

    return true
  }

  const uploadDeDocumentos = async (
    edicoes: UploadDocumentos[],
    criacoes: UploadDocumentos[],
    analises: UploadDocumentos[]
  ): Promise<void> => {
    try {
      definirCarregando(true)

      if (edicoes.length > 0) {
        const sucesso = await uploadDeEdicao(edicoes)
        if (!sucesso) return
      }

      if (criacoes.length > 0) {
        const sucesso = await uploadDeCriacao(criacoes)
        if (!sucesso) return
      }

      if (analises.length > 0 && !somenteConsulta) {
        const sucesso = await uploadDeAnalises(analises)
        if (!sucesso) return
      }

      toast('Documentos salvos com sucesso!', { type: 'success' })
      history.goBack()
    } catch (erro) {
      if ((erro as any)?.isAxiosError) {
        return
      }

      const mensagens = await getApiError(erro as Error)
      toast(mensagens[0] || erroAoProcessarDocumentos, toastOptions)
    } finally {
      definirCarregando(false)
    }
  }

  const eventoDeUpload = async (): Promise<void> => {
    const {
      edicoes,
      criacoes,
      analises,
      contador
    } = selecaoDeDocumentosParaEnvio(documentos)

    const contadorSalvavel = somenteConsulta
      ? edicoes.length + criacoes.length
      : contador

    if (contadorSalvavel === 0) {
      toast('Nenhuma alteração pendente para salvar', { type: 'warning' })
      return
    }

    await uploadDeDocumentos(edicoes, criacoes, analises)
  }

  const obterDownloadDeDocumentos = async (documentoId: string): Promise<void> => {
    try {
      await Api.DownloadDocumentosAlunoCertificacao(dadosDoAluno.id, documentoId)
    } catch (erro) {
      toast(erroAoBaixarDocumentos, toastOptions)
    }
  }

  const visualizarDocumento = async (documentoId: string) => {
    try {
      const documento = await Api.RequisitarDocumentoAlunoCertificacao(
        dadosDoAluno.id,
        documentoId
      )

      if (documento) {
        const urlDoDocumento = montarUrlDeVisualizacao(
          documento.base64,
          documento.contentType
        )

        if (!urlDoDocumento) {
          toast(erroAoObterDocumentos, toastOptions)
          return
        }

        modalVisualizacaoRef?.current?.abrir(urlDoDocumento)
      }
    } catch (error) {
      toast(erroAoObterDocumentos, toastOptions)
    }
  }

  const obterDocumentacao = async (): Promise<void> => {
    try {
      definirPronto(false)
      limparErro()
      const aluno = await obterAlunoPorId(match.params.id)

      if (aluno) {
        definirDadosDoAluno(aluno)
        await obterResumoDeDocumentos(aluno.id)
      }

      definirPronto(true)
    } catch (error) {
      definirErro({ mensagens: erroAoCarregarDados })
    }
  }

  const aprovacao = (id: string): void => {
    const index = documentos.findIndex(x => x.id === id)

    if (index >= 0) {
      const documentoAtualizado = { ...documentos[index] }
      documentoAtualizado.analisado = true
      documentoAtualizado.status = SituacaoUpload.Aprovado
      atualizar(documentoAtualizado)
    }
  }

  const rejeicao = (id: string): void => {
    definirRejeicaoDeDocumento({ id: id })
    modalMotivoRejeicaoRef?.current?.abrir()
  }

  const obterMotivoDaRejeicao = (dados: ModalMotivoRejeicaoDados) => {
    const index = documentos.findIndex(
      x => x.id === rejeicaoDeDocumento.id
    )

    if (index >= 0) {
      const documentoAtualizado = { ...documentos[index] }
      documentoAtualizado.analisado = true
      documentoAtualizado.status = SituacaoUpload.Recusado
      documentoAtualizado.motivoDaRejeicao = dados.motivoDaRejeicao
      atualizar(documentoAtualizado)
    }

    modalMotivoRejeicaoRef?.current?.fechar()
    definirRejeicaoDeDocumento(null)
  }

  const fecharModalDeCancelamento = () => {
    modalDeCancelamentoRef?.current?.fechar()
  }

  const abrirModalDeCancelamento = () => {
    modalDeCancelamentoRef?.current?.abrir()
  }

  useEffect(() => {
    obterDocumentacao()
  }, [match.params.id])

  const documentosOrdenados = documentos.sort((a, b) => a.ordemExibicao - b.ordemExibicao)

  const TipoDocumentoUpload = {
    [TipoDocumentoAlunoCertificacao.Rg]: 'RG - Frente',
    [TipoDocumentoAlunoCertificacao.RgVerso]: 'RG - Verso',
    [TipoDocumentoAlunoCertificacao.DiplomaGraduacao]: 'Diploma de Graduação - Frente',
    [TipoDocumentoAlunoCertificacao.DiplomaGraduacaoVerso]: 'Diploma de Graduação - Verso'
  }

  if (erro) return <ErroContainerLayout />
  if (!pronto) return <Carregando />

  return (
    <ContainerDaPagina>
      {carregando && <Carregando />}

      <ContainerBreadcrumbs>
        <Breadcrumb atalhos={[]} titulo={tituloDaPagina} />
      </ContainerBreadcrumbs>

      <TituloComplementar>{tituloDaPagina}</TituloComplementar>

      <DescricaoContainer>
        <p>Nome: {dadosDoAluno?.nome}</p>
        <ParagrafoDaNacionalidade>
          Nacionalidade: {dadosDoAluno?.nacionalidade}
        </ParagrafoDaNacionalidade>
        <p>CPF: {dadosDoAluno?.cpf}</p>
        <p>E-mail: {dadosDoAluno?.email}</p>
      </DescricaoContainer>

      <Dicas>
        {somenteConsulta
          ? DICA_CONSULTA_DOCUMENTOS_FILA
          : 'O envio dos documentos é obrigatório para a emissão do certificado. Analise cada documento e aprove ou recuse conforme a conformidade.'}
      </Dicas>

      {documentosOrdenados.map((documento) => (
        <UploadDeDocumentos
          key={documento.id}
          documento={documento}
          eventoDeVisualizacao={visualizarDocumento}
          eventoDeDownload={obterDownloadDeDocumentos}
          eventoDeMudanca={atualizar}
          controleDeAprovacao={{
            ativo: !somenteConsulta,
            eventoDeAprovacao: aprovacao,
            eventoDeRejeicao: rejeicao
          }}
          modoVisualizacao={true}
          somenteConsulta={somenteConsulta}
        />
      ))}

      <ContainerDosBotoes>
        <Botao
          texto={somenteConsulta ? 'Voltar' : 'Cancelar'}
          onClick={somenteConsulta ? () => history.goBack() : abrirModalDeCancelamento}
        />
        {!somenteConsulta && (
          <BotaoDeSalvar texto="Salvar" onClick={eventoDeUpload} />
        )}
      </ContainerDosBotoes>

      <Modal
        ref={modalDeCancelamentoRef}
        titulo="Deseja cancelar?"
        acaoPrimaria={{
          titulo: 'Sim',
          acao: () => history.goBack()
        }}
        acaoSecundario={{
          titulo: 'Não',
          acao: fecharModalDeCancelamento
        }}
      >
        Tem certeza que deseja sair sem salvar as alterações?
      </Modal>

      <ModalMotivoRejeicao
        ref={modalMotivoRejeicaoRef}
        acaoPrimaria={obterMotivoDaRejeicao}
      />

      <ModalVisualizacaoDocumento
        ref={modalVisualizacaoRef}
        id="modal-visualizacao-documento-aluno-certificacao"
      />
    </ContainerDaPagina>
  )
}

const Container: FC<DocumentosAlunoCertificacaoProps> = (
  props: DocumentosAlunoCertificacaoProps
) => (
  <ErroLayoutContainer.Provider>
    <DocumentosAlunoCertificacao {...props} />
  </ErroLayoutContainer.Provider>
)

export default withRouter(Container)
